'use client';
import { Link } from '@/shared/ui/link';
import { BodyTextMediumC } from '@/shared/ui/typography2';
import { useRouter } from 'next/navigation';
import styled from 'styled-components';
import { useCurrentLocale, useI18n } from '@locales/client';

export const NavigationMenu = () => {
  const router = useRouter();
  const loc = useI18n();
  const locale = useCurrentLocale();

  const buttons: Array<{ page: string; text: string }> = [
    { page: '', text: 'common.footer.home' },
    { page: 'games', text: 'common.footer.games' },
    { page: 'betting', text: 'common.footer.betting' },
    { page: 'profile/bonuses', text: 'common.footer.bonus' },
    { page: 'status', text: 'minibanners.status' },
    { page: 'games/favorite', text: 'mini_games_banners.wishlist' },
  ];

  const getBullonLink = (page) => {
    return `/${locale}/${page}`;
  };
  return (
    <PortalMenuContainer>
      <PortalMenu>
        {buttons.map((button) => (
          <PortalButton key={button.page} href={getBullonLink(button.page)}>
            <BodyTextMediumC>{loc(button.text)}</BodyTextMediumC>
          </PortalButton>
        ))}
      </PortalMenu>
    </PortalMenuContainer>
  );
};

const PortalMenuContainer = styled.div`
  width: 100%;
  height: 44px;
  overflow-x: auto;
`;

const PortalMenu = styled.nav`
  display: grid;
  height: 44px;
  grid-template-columns: repeat(6, auto);
  gap: 12px;
`;
const PortalButton = styled(Link)`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  gap: 9px;
  flex: 1 0 0;
  align-self: stretch;
  cursor: pointer;

  border-radius: 8px;
  background: #27262b;
  min-width: 100px;

  @media (max-width: 768px) {
    width: 100px;
  }
`;
